<template>
  <!--  楼盘信息-->
  <div class="poor">
    <div class="poor_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small">
          <el-row style="margin: 0 0 20px 82px">
            <el-checkbox v-model="searchData.isRenqi">人气</el-checkbox>
            <el-checkbox v-model="searchData.isResou">热搜</el-checkbox>
            <el-checkbox v-model="searchData.isKoubei">口碑</el-checkbox>
            <!-- <el-col :span="8">
              <el-form-item label="人气">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.isRenqi"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="热搜">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.isResou"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="口碑">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.isKoubei"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-form-item>
            <el-button
              size="mini"
              style="width: 90px; margin-left: 80px"
              type="primary"
              @click="messageAdd"
              v-if="menuPerm('floorSearch:insert')"
              >添加</el-button
            >
            <el-button
              size="mini"
              style="margin-left: 20px"
              type="primary"
              @click="messageSearch"
              >查询</el-button
            >

            <el-button
              size="mini"
              style="margin-left: 20px"
              type="primary"
              @click="topicClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card v-loading="loading">
        <el-table
          :data="list"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="floorName"
            label="楼盘名称"
            align="center"
            width="400"
          ></el-table-column>
          <el-table-column
            prop="isRenqi"
            label="人气"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <el-button v-if="row.isRenqi == 1" size="mini" type="success">
                是
              </el-button>
              <el-button v-if="row.isRenqi == 0" size="mini" type="info">
                否
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="isResou"
            label="热搜"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <el-button v-if="row.isResou == 1" size="mini" type="success"
                >是</el-button
              >
              <el-button v-if="row.isResou == 0" size="mini" type="info"
                >否</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="isKoubei"
            label="口碑"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <el-button v-if="row.isKoubei == 1" size="mini" type="success"
                >是</el-button
              >
              <el-button v-if="row.isKoubei == 0" size="mini" type="info"
                >否</el-button
              >
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="messageChange(row)"
                  v-if="menuPerm('floorSearch:update')"
                  >修改</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="messageDelete(row)"
                  v-if="menuPerm('floorSearch:delete')"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <!-- 添加页面 -->
      <a-drawer
        title="添加"
        :width="1300"
        :visible="addvisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Add :AddData="addData" />
      </a-drawer>
      <!-- 修改页面 -->
      <a-drawer
        title="修改"
        :width="1300"
        :visible="changevisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Change :ChangeData="changeData" />
      </a-drawer>
      <!-- 删除弹出框 -->
      <a-modal
        :visible="delOpen"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <p>确定要删除吗？</p>
      </a-modal>
    </div>
  </div>
</template>
<script>
import Change from "./change";
import Add from "./add";
export default {
  components: {
    Change,
    Add,
  },
  data() {
    return {
      addvisible: false,
      changevisible: false,
      delOpen: false,
      list: [], //留言列表
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示

      //查询的数据：
      searchData: {
        isResou: "", //热搜
        isRenqi: "", //人气
        isKoubei: "", //口碑
      },
      //类型--下拉框：
      messageType: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      loading: false,
      addData: [],
      changeData: [],
      deleteId: "",
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //列表：
    getList() {
      this.postAxios("/floorSearch/list", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        floorSearch: {
          isResou: this.searchData.isResou, //是否热搜
          isRenqi: this.searchData.isRenqi, //是否人气
          isKoubei: this.searchData.isKoubei, //是否口碑
        },
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 添加
    messageAdd(row) {
      this.addvisible = true;
      //   this.$router.push("/houseInfoAdd");
    },
    // 修改
    messageChange(row) {
      this.changevisible = true;
      this.changeData = row;
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios(`/floorSearch/delete?id=${this.deleteId}`).then((res) => {
        if (res.success == true) {
          this.getList();
          this.$message.success(res.message);
          this.delOpen = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 删除
    messageDelete(row) {
      this.deleteId = row.id;
      this.delOpen = true;
    },
    onClose() {
      this.addvisible = false;
      this.changevisible = false;
      this.getList();
    },
    //查询列表：
    messageSearch() {
      this.currentPage = 1;
      this.loading = true;
      this.postAxios("/floorSearch/list", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        floorSearch: {
          isResou: this.searchData.isResou ? 1 : "", //是否热搜
          isRenqi: this.searchData.isRenqi ? 1 : "", //是否人气
          isKoubei: this.searchData.isKoubei ? 1 : "", //是否口碑
        },
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;
          this.loading = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //清空查询条件：
    topicClear() {
      this.searchData.isKoubei=""
      this.searchData.isRenqi=""
      this.searchData.isResou=""
      this.getList();
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  created() {
    this.getList(); //获取留言列表
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.poor {
  width: 100%;
  height: 100%;
  .poor_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .done {
      display: flex;
      flex-direction: column;
      width: 100px;
      margin: 0 auto;

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>